import Tabs from '@/components/Tabs/Tabs';
import styles from './Tutorial.module.less';
import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { projectController } from '@/api';
import { useSelector } from 'react-redux';
import tutorialList from '@/utils/tutorial';
export default function Home() {
  const navigate = useNavigate();
  const [list, setList] = useState(tutorialList);

  useEffect(() => {}, []);

  return (
    <div className={styles.container}>
      <div className={styles.caption}>Tutorial</div>
      <div className={styles.title}>
        Explore the cutting-edge capabilities that set our platform apart, from industry-leading
        generation speed and quality to intuitive workflows designed to enhance your 3D creation
        experience.
      </div>
      <div className={styles.list}>
        {list.map((item) => {
          return (
            <div
              className={styles.item}
              onClick={() => {
                navigate('/tutorialDetail/' + item.id);
              }}>
              <img className={styles.coverimg} src={item.image}></img>
              <div className={styles.title}>{item.title}</div>
              <div className={styles.subtitle}>{item.subTitle}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
